<template>
    <!--  USAGE  -->
    <!-- <FileSelect @selectedfiles="setFiles($event)" :selectcount="1"  :trigger="openfiles" @close="openfiles=false"  />  -->
    <!-- available props: [filetype, selectcount, button] -->
    <!--event - '@selectedfiles' emits[fileurl-1, fileurl-2, fileurl-3... ] -->
    <v-dialog v-model="dialog" scrollable max-width="600">
        <template v-slot:activator="{ on }">
            <v-btn
               color="indigo"
               dark
               v-on="on"
            >
                <v-icon>{{icons.notes}}</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                Select Files
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-card flat outlined v-for="f in files" :key="f.Key" class="d-inline-block mx-auto mb-2">
                        <v-card-text class="pa-0">
                            <v-img
                                    height="100"
                                    width="100"
                                    :src="prefix+f.Key"
                            ></v-img>
                        </v-card-text>
                        <v-card-actions class="pa-0">
                            <v-spacer></v-spacer>
                            <v-checkbox  dense class="pa-0 ma-0" v-model="selectedfiles" :value="prefix+f.Key" />
                        </v-card-actions>
                    </v-card>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn text @click="closeClean()">
                    <v-icon>{{icons.close}}</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import AWS from 'aws-sdk'
  export default {
    props:{
      filetype: { //unused for now
        type: String,
        required: false,
        default: 'image/*'// video/*
      },
      selectcount: {
        //the number of files desired for selection
        type: Number,
        required: false,
        default: 0 //set to 0 for unlimited slections
      },
      trigger: {
        type: Boolean,
        required: false,
        default: false// video/*
      }
    },
    components: {},
    name: "FileSelect",
    data: ()=>({
      files: [],
      activeinfo:undefined,
      infodialog:false,
      activecopy: undefined,
      selectedfiles: [],
      dialog: false
    }),
    computed:{
      ...mapState(['idpool','userpool','org','icons']),
      prefix(){
        return `https://orgbucket-${this.org.partkey}.s3-us-west-2.amazonaws.com/`
      }
    },
    watch: {
      trigger(n){
        if(n===true){
          this.dialog=true
        } else {
          this.dialog=false
        }
      },
      selectedfiles(n,o){
        if(n.length>0){
          if(this.selectcount===1){
            this.$emit('selectedfiles', n[0])
            this.closeClean()
          } else {
            this.$emit('selectedfiles', n)
            this.closeClean()
          }
        }
      }
    },
    mounted() {
      if(!this.org){
        let em = this;
        setTimeout(function(){
          em.getFiles()
        },2000)
      } else {
        this.getFiles()
      }
    },
    methods: {
      async getFiles() {
        //SET THIS STUFF GLOBALLY, MAYBE...
        let em = this;
        let session = await this.$store.dispatch('cognito/fetchSession')
        let idKey = 'cognito-idp.us-west-2.amazonaws.com/' + this.userpool
        AWS.config.region = 'us-west-2';
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: 'us-west-2:298bb257-e38c-4729-a20e-e7f803403933',
          Logins: {
            [idKey]: session.idToken.jwtToken
          }
        });
        var s3 = new AWS.S3({
          apiVersion: '2006-03-01',
          params: {
            Bucket: 'orgbucket-'+em.org.partkey,
          }
        });
        AWS.config.credentials.get(function (err) {
          if (err){
            this.disabled=false
            return console.log(err)
          }
          s3.listObjects({Delimiter: '/'}, function(err, data) {
            em.files = data.Contents
          })
        })
      },
      async deteFile(key,i){
        let em = this;
        let session = await this.$store.dispatch('cognito/fetchSession')
        let idKey = 'cognito-idp.us-west-2.amazonaws.com/' + this.userpool
        AWS.config.region = 'us-west-2';
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: 'us-west-2:298bb257-e38c-4729-a20e-e7f803403933',
          Logins: {
            [idKey]: session.idToken.jwtToken
          }
        });
        var s3 = new AWS.S3({
          apiVersion: '2006-03-01',
          params: {
            Bucket: 'orgbucket-'+em.org.partkey,
          }
        });
        s3.deleteObject({ Key: key }, function(err, data) {
          if (err) {
            return alert("There was an error deleting your photo: ", err.message);
          }
          em.files.splice(i,1)
        });
      },
      closeClean(){
        this.$emit('close',true) //to handle remote close events
        this.selectedfiles = []
        this.dialog = false
      }
    }
  }
</script>

<style scoped>
    .selected {
        @extend .font-weight-black
    }
</style>